import { ReactNode } from 'react';
import type { SelectedEquipmentInfo as SelectedEquipmentInfoType } from 'app/[lang]/[esite]/(core)/_header/components/equipment-widget/types';
import NoEquipmentWrapper from './no-equipment/no-equipment';
import SelectedEquipmentWrapper from './selected-equipment/selected-equipment';
import cx from 'classnames';
import styles from './equipment-widget-redesigned.module.scss';

export const EquipmentWidgetRedesigned = ({
  widgetContent,
  hasEquipmentsToSelect,
  isEquipmentSelected,
  selectedEquipmentInfo,
  shouldTriggerNER,
  shouldDisplayCheckBox
}: {
  widgetContent: ReactNode;
  hasEquipmentsToSelect: boolean;
  isEquipmentSelected: boolean;
  selectedEquipmentInfo: SelectedEquipmentInfoType;
  shouldTriggerNER: boolean;
  shouldDisplayCheckBox?: boolean;
}) => {
  return (
    <section
      data-testid="equipment-widget-redesigned"
      className={cx(
        'border border-1 border-LightGray p-3 rounded-3',
        styles['equipment-widget']
      )}
    >
      {isEquipmentSelected ? (
        <SelectedEquipmentWrapper
          selectedEquipmentInfo={selectedEquipmentInfo}
          shouldTriggerNER={shouldTriggerNER}
          shouldDisplayCheckBox={shouldDisplayCheckBox}
        />
      ) : (
        <NoEquipmentWrapper hasEquipmentsToSelect={hasEquipmentsToSelect} />
      )}
      {widgetContent}
    </section>
  );
};
